import React, { useState } from 'react';
import { Button, Menu, MenuItem, LinearProgress, Typography, Divider } from '@mui/material';

interface FileUpload {
  file: File & { webkitRelativePath: string };
  status: 'pending' | 'processing' | 'success' | 'error';
  taskId?: string;
  error?: string;
}

interface UploadStatusDropdownProps {
  uploads: FileUpload[];
}

const UploadStatusDropdown = ({ uploads }: UploadStatusDropdownProps) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <Button variant="outlined" color="secondary" onClick={handleClick}>
        Stato Upload
      </Button>
      <Menu anchorEl={anchorEl} open={open} onClose={handleClose}>
        {uploads.length === 0 && (
          <MenuItem disabled>
            <Typography variant="body2">Nessun upload in corso</Typography>
          </MenuItem>
        )}

        {uploads.map((u, idx) => (
          <MenuItem key={idx} sx={{ flexDirection: 'column', alignItems: 'flex-start' }}>
            <Typography variant="body2">{u.file.webkitRelativePath}</Typography>
            {u.status === 'pending' && <span>⏳ In attesa</span>}
            {u.status === 'processing' && (
              <div style={{ width: '100%' }}>
                <LinearProgress />
                <Typography variant="caption">Task: {u.taskId}</Typography>
              </div>
            )}
            {u.status === 'success' && <span>✅ Successo</span>}
            {u.status === 'error' && (
              <Typography variant="body2" color="error">
                ❌ Errore: {u.error}
              </Typography>
            )}
            {idx < uploads.length - 1 && <Divider />}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};
export default UploadStatusDropdown;
